import { useEffect, useState } from "react";
import { fetchPermitInfo, PermitInfo, PermitSummary } from "../Services/permitSummaryApi";

const NOTHING: PermitInfo = { summary: null, coverage: null };

/**
 * The public permit summary for a home, and whether its city is covered at
 * all, fetched once when `enabled`. Nothing while loading or on any failure:
 * the claim prompt reads the same without it, so a failure stays invisible.
 */
export const usePermitInfo = (propertyId: string, enabled: boolean): PermitInfo => {
  const [info, setInfo] = useState<PermitInfo>(NOTHING);
  useEffect(() => {
    setInfo(NOTHING);
    if (!enabled || !propertyId) return;
    let cancelled = false;
    fetchPermitInfo(propertyId)
      .then((i) => {
        if (!cancelled) setInfo(i);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [propertyId, enabled]);
  return info;
};

/** Just the summary (null when there's nothing to show). */
export const usePermitSummary = (propertyId: string, enabled: boolean): PermitSummary | null =>
  usePermitInfo(propertyId, enabled).summary;
